import { Button, TYPE_BUTTON } from '@eventbrite/eds-button';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './ConfirmDialog.scss';

export interface ConfirmDialogProps {
    infoMessage?: GenericLazyString;
    confirmButtonText: GenericLazyString;
    cancelButtonText: GenericLazyString;
    onCancelButtonClick: () => void;
    onConfirmButtonClick: () => void;
}

export const ConfirmDialog: React.FunctionComponent<ConfirmDialogProps> = ({
    infoMessage,
    confirmButtonText,
    cancelButtonText,
    onCancelButtonClick,
    onConfirmButtonClick,
}) => (
    <div className="confirm-widget">
        <div
            data-spec="confirm-widget-info-message"
            className="eds-l-pad-bot-6"
        >
            {infoMessage}
        </div>
        <div className="eds-g-grid eds-l-pad-bot-20">
            <div className="eds-g-cell eds-g-cell-6-12 eds-l-pad-hor-2">
                <Button
                    data-spec="confirm-widget-cancel-button"
                    type={TYPE_BUTTON}
                    onClick={onCancelButtonClick}
                    size="block"
                    data-automation="checkout-widget-return-to-checkout-button"
                >
                    {cancelButtonText}
                </Button>
            </div>
            <div className="eds-g-cell eds-g-cell-6-12 eds-l-pad-hor-2">
                <Button
                    data-spec="confirm-widget-confirm-button"
                    type={TYPE_BUTTON}
                    style="fill"
                    size="block"
                    onClick={onConfirmButtonClick}
                    data-automation="checkout-widget-leave-checkout-button"
                >
                    {confirmButtonText}
                </Button>
            </div>
        </div>
    </div>
);

export default ConfirmDialog;
